import { GqlDispensaries } from 'types/graphql';

export const checkDispensaryDPOSIntegration = (
  dispensary?: Pick<GqlDispensaries, 'menuIntegration'> | null
): boolean =>
  Array.isArray(dispensary?.menuIntegration) &&
  dispensary.menuIntegration.some(
    (integration) =>
      integration?.integrationCategory === 'pos' && integration.adapter === 'leaflogix' && integration.live
  );
